// extracted by mini-css-extract-plugin
export default {"header":"EventsGeneral_header__0scYi","events":"EventsGeneral_events__LgXyv","moreBtn":"EventsGeneral_moreBtn__lGlTv","disabled":"EventsGeneral_disabled__wqj5q"};